module.exports = __webpack_public_path__ + "img/744.9ca5a1ad.jpg";